import { withAdpCombine } from '../../config/context/config';
import { ImageCrop as ImageCropInner } from './components/ImageCrop';
export var ImageCrop = withAdpCombine(ImageCropInner);